import { BASE_URL, COMPETENCY, COMPETENCY_By_Role, IMPORT_COMPETENCY, IMPORT_DEPARTMENTS, IMPORT_JOBS } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import {
  ICompetency,
  ICompetencyByRole,
  ICompetencyInput,
} from "models/competency";

export async function getCompetencies(
  params: string = ""
): Promise<ICompetency[]> {
  const response = await axios.get(BASE_URL + COMPETENCY + params);
  return response.data;
}

export async function getCompetenciesByRole(
  params: string = ""
): Promise<ICompetencyByRole[]> {
  const response = await axios.get(BASE_URL + COMPETENCY_By_Role + params);
  return response.data;
}

export async function addCompetency(data: ICompetencyInput) {
  const response = await axios.post(BASE_URL + COMPETENCY, data);
  return response.data;
}

export async function importCompetency() {
  const response = await axios.post(BASE_URL + IMPORT_COMPETENCY);
  return response.data;
}

export async function importDepartments() {
  const response = await axios.post(BASE_URL + IMPORT_DEPARTMENTS);
  return response.data;
}

export async function importJobs() {
  const response = await axios.post(BASE_URL + IMPORT_JOBS);
  return response.data;
}


export async function editCompetency(data: ICompetencyInput, id: string) {
  const response = await axios.patch(BASE_URL + COMPETENCY + "/" + id, data);
  return response.data;
}

export async function deleteCompetency(id: string) {
  const response = await axios.delete(BASE_URL + COMPETENCY + "/" + id);
  return response.data;
}

export const CompetencyCells: HeadCell[] = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "nameAr",
    numeric: false,
    disablePadding: false,
    label: "T_name_Ar",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
